import * as React from "react";
import { DiscountInfoBox, LeftTopTags, RightTopTag } from "./styles";
import CountDown from "../../CountDown";
import { PoolExtraFlashInfo, ExtraIconPro } from "../../../../../services/product";

interface DiscountInfoCardLTProps {
	imgOnTopRight?: ExtraIconPro;
	imgOnTopLeft?: ExtraIconPro;
	imgOnTopLeft2?: ExtraIconPro;
	imgOnBottomLeft?: ExtraIconPro;
	className?: string;
	flash?: PoolExtraFlashInfo;
}
export default class DiscountInfoCard extends React.PureComponent<DiscountInfoCardLTProps> {
	getStyle = (item: ExtraIconPro) => {
		return { height: item?.height || "auto" };
	};
	renderImgOnTopLeft = () => {
		const { imgOnTopLeft2, imgOnTopLeft } = this.props;
		// tagInfo左上
		if (imgOnTopLeft?.img || imgOnTopLeft2?.img) {
			return (
				<LeftTopTags>
					{imgOnTopLeft?.img && <img src={imgOnTopLeft?.img} />}
					{imgOnTopLeft2?.img && <img src={imgOnTopLeft2?.img} />}
				</LeftTopTags>
			);
		}
		return null;
	};
	renderImgOnTopRight = () => {
		if (this.props.imgOnTopRight?.img) {
			return <RightTopTag src={this.props.imgOnTopRight.img} alt="" />;
		}
		return null;
	};
	renderImgOnBottomLeft = () => {
		if (this.props.imgOnBottomLeft?.img) {
			return <img className={"themeTag"} src={this.props.imgOnBottomLeft.img} alt="" />;
		}
		return null;
	};
	render() {
		const { imgOnTopRight, imgOnTopLeft, imgOnBottomLeft, className = "", flash } = this.props;
		if (!imgOnTopRight && !imgOnTopLeft && !imgOnBottomLeft) {
			return null;
		}
		return (
			<DiscountInfoBox className={`${className}`}>
				{this.renderImgOnTopLeft()}
				{this.renderImgOnTopRight()}
				{this.renderImgOnBottomLeft()}
				{flash?.countdownToEnd && <CountDown countInfo={flash} />}
			</DiscountInfoBox>
		);
	}
}
